import { Tooltip, Typography } from '@mui/material';

/**
 * TruncatedText component
 *
 * Shows text on a single line. If it is wider than the available space it is cut off
 * with an ellipsis ("...") and the full text is shown in a tooltip on hover.
 * Use it for long names / emails in tables so they can't stretch the table width.
 *
 * @param {string} text - The text to display (and show in the tooltip).
 * @param {number|string} maxWidth - Max width before truncating. Omit it when the parent (e.g. a flex item with minWidth: 0) already limits the width.
 * @param {string} placement - Tooltip position. Defaults to "top".
 * @param {object} sx - Extra styles for the text, e.g. { fontWeight: "bold" }.
 * @param {node} children - Optional styled content to show instead of `text` (the tooltip still shows `text`).
 *
 * @returns {JSX.Element} The TruncatedText component.
 */
export const TruncatedText = ({ text, maxWidth, placement = "top", sx = {}, children, ...props }) => {

    return (
        <Tooltip title={text || ""} placement={placement}>
            <Typography
                noWrap
                sx={{ fontSize: "inherit", maxWidth, ...sx }}
                {...props}
            >
                {children ?? text}
            </Typography>
        </Tooltip>
    );
};
